var React = require('react');

function Left (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35 18C35 8.61458 27.3854 1 18 1C8.61458 1 1 8.61458 1 18C1 27.3854 8.61458 35 18 35C27.3854 35 35 27.3854 35 18Z","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M17.4134 25.0832L10.385 17.9999L17.4134 10.9166","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M11.3623 18H25.6149","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Left.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Left;

Left.default = Left;
